import { axiosClient, buildQuery } from '@nx-frontend/shared/api';
import { generalEnv } from '@nx-frontend/shared/env';
import { NoteDto } from '@nx-frontend/shared/types';
import { GetNotesPayload, GetNotesResult } from '@nx-frontend/shared/types';

export async function getNotes({
  userId,
  workspaceId,
  range = {},
  filter,
  rootId,
  counters,
  countersTypes,
  fetchSharedForPortal,
  count,
  order,
}: GetNotesPayload): Promise<GetNotesResult | null> {
  try {
    const _query = {
      range,
      filter,
      order: undefined === order ? ['title', 'ASC'] : order,
      count: false === count ? false : true,
      rootId,
      counters: Boolean(counters),
      countersTypes: countersTypes && countersTypes.length ? countersTypes.join(',') : undefined,
    };
    const queryParams = buildQuery(undefined === fetchSharedForPortal ? _query : { ..._query, fetchSharedForPortal });
    const query = queryParams ? `?${queryParams}` : '';
    const host = generalEnv.noteServiceUrl;
    const response = await axiosClient.get<NoteDto[]>(`${host}/v1/workspaces/${workspaceId}/notes${query}`, {
      headers: {
        Authorization: `internal ${userId}:auto`,
      },
    });
    return {
      items: response.data,
      total: parseInt(response.headers['x-total-count'] || 0),
    };
  } catch (err) {
    console.log(`getNotes error: ${err}`);
  }
  return null;
}
